import * as React from 'react';
import {classNames, variationName} from '@shopify/react-utilities/styles';
import {BackgroundColors, Spacing, TextAlign} from '../Types';
import styles from './VerticalRhythm.scss';

export interface VerticalRhythmProps {
  className?: string;
  textAlign?: TextAlign;
  backgroundColor?: BackgroundColors;
  constrained?: boolean;
  paddingTop?: Spacing;
  paddingBottom?: Spacing;
  marginTop?: Spacing;
  marginBottom?: Spacing;
  children: React.ReactNode;
}

export function VerticalRhythm(props: VerticalRhythmProps) {
  const {
    className,
    constrained,
    textAlign = 'inherit',
    marginTop = 'none',
    paddingTop = 'none',
    marginBottom = 'none',
    paddingBottom = 'none',
    backgroundColor = 'white',
    children,
  } = props;

  const spacingClassName = classNames(
    className,
    {[styles.constrained]: constrained},
    styles[variationName('textAlign', textAlign)],
    styles[variationName('marginTop', marginTop)],
    styles[variationName('paddingTop', paddingTop)],
    styles[variationName('marginBottom', marginBottom)],
    styles[variationName('paddingBottom', paddingBottom)],
    styles[variationName('background', backgroundColor)],
  );

  return (
    <section className={spacingClassName}>
      {children}
    </section>
  );
}
